import { storyblokEditable } from "@storyblok/react/rsc";
import type { AssetStoryblok } from "@/component-types-sb";

// sun-100 color for player accent
const ACCENT_COLOR = "#FDFD92";

type VideoEmbedStoryblok = {
  playback_id: string;
  title?: string;
  thumbnail?: AssetStoryblok;
  thumbnail_time?: number;
  _uid: string;
  component: "video_embed";
};

type VideoEmbedProps = {
  blok: VideoEmbedStoryblok;
};

const VideoEmbed = ({ blok }: VideoEmbedProps) => {
  if (!blok.playback_id) {
    return null;
  }

  // Build iframe URL with optional parameters
  const params = new URLSearchParams();
  params.set("accent-color", ACCENT_COLOR);
  if (blok.title) {
    params.set("metadata-video-title", blok.title);
  }
  if (blok.thumbnail?.filename) {
    params.set("poster", blok.thumbnail.filename);
  }
  if (blok.thumbnail_time) {
    params.set("thumbnail-time", blok.thumbnail_time.toString());
  }

  const queryString = params.toString();
  const iframeSrc = `https://player.mux.com/${blok.playback_id}?${queryString}`;

  return (
    <div
      className="not-prose my-8 rounded-2xl overflow-hidden aspect-video"
      {...storyblokEditable(blok)}
    >
      <iframe
        src={iframeSrc}
        title={blok.title || "Video"}
        className="w-full h-full border-0"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default VideoEmbed;
